import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { GlobalService } from 'src/app/services/common/global.service';
import { ResourceService } from 'src/app/services/common/resource.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { GlobalVariables } from 'global-variables';

@Component({
  selector: 'app-share-campaign',
  templateUrl: './share-campaign.component.html',
  styleUrls: ['./share-campaign.component.scss']
})
export class ShareCampaignComponent implements OnInit {

  qrCodeImage = "";
  qrCodeValue = "";
  resource: any = {};

  encodeQrCodeValue ="";

  constructor(
    private campaignsService: CampaignsService,
    private clipboard: Clipboard,
    private globalService: GlobalService,
    private resourceService: ResourceService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<ShareCampaignComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(response => {
      this.resource = response;
    });
    this.getCampaignQrCode();
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }

  getCampaignQrCode() {
    this.campaignsService.qrCode(this.data.campaignId).subscribe((response: any) => {
      if (response.success) {
        this.qrCodeImage = response.data.qrCodeURL;
        this.qrCodeValue = response.data.qrCodeValue;

        
        let url = GlobalVariables.couponShareURL;

        this.qrCodeValue = url + "campaigns/" + this.data.campaignId;
        this.encodeQrCodeValue = encodeURIComponent(this.qrCodeValue);
      }
    })
  }

  onClickCopyURL() {
    this.clipboard.copy(this.qrCodeValue);
    this.alertService.showSuccess(this.resource.url_copied)
  }

  onClickDownloadQrCode() {
    // converts base 64 encoded image to blobData
    let blobData = this.globalService.convertBase64ToBlob(this.qrCodeImage);

    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.data.campaignName;
    link.click();
  }
}
